import type { PatternType } from '@miyuki/types';

/**
 * Límites del patrón de pulsera. Son las invariantes I1, I2, I5 e I6 del
 * modelo de datos expresadas en un solo lugar, para que la validación, los
 * esquemas y la interfaz no puedan discrepar entre sí.
 */

export const MIN_COLUMNS = 1;
export const MAX_COLUMNS = 30;

export const MIN_ROWS = 1;
export const MAX_ROWS = 500;

export const MIN_COLORS = 1;
export const MAX_COLORS = 99;

export const MAX_NAME_LENGTH = 60;

/**
 * Los valores concretos del tipo de patrón viven aquí y no junto al tipo: el
 * Artículo II.3 pide que `@miyuki/types` no lleve código ejecutable, y un array
 * lo es.
 */
export const PATTERN_TYPES: readonly PatternType[] = ['loom', 'peyote'];

/** Con qué tejido nace un diseño al que nadie le dijo otra cosa. */
export const DEFAULT_PATTERN_TYPE: PatternType = 'loom';

/** Con cuánto avance nace un diseño: sin tejer (RF-14). */
export const DEFAULT_PROGRESS = 0;

/**
 * Si el sentido de lectura de la fila alterna por defecto. Alterna, porque es
 * lo que ocurre al tejer de ida y vuelta: el hilo vuelve por donde llegó
 * (RF-28c).
 */
export const DEFAULT_READING_ALTERNATES = true;
